import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getPaidLeaveBalanceStart,
  getPaidLeaveBalanceSuccess,
  getPaidLeaveBalanceFailed,
} from "../redux/getPaidLeaveBalance";
import { getPaidLeaveBalanceApi } from "core/http/service/timeKeeping";

function* getPaidLeaveBalanceWork(action) {
  try {
    const res = yield call(getPaidLeaveBalanceApi, action.payload);

    yield put({
      type: getPaidLeaveBalanceSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getPaidLeaveBalanceFailed.type,
    });
  }
}

function* watchGetPaidLeaveBalance() {
  yield takeLatest(getPaidLeaveBalanceStart.type, getPaidLeaveBalanceWork);
}

export default function* getPaidLeaveBalanceSaga() {
  yield all([watchGetPaidLeaveBalance()]);
}
